// extracted by mini-css-extract-plugin
export default {"inputBaseStyle":"_-_-record-it-components-src-input-__inputBaseStyle"};